import React from 'react';
import './styles/login.scss';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './redux/actions';

class SetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      passwordConfirmation: '',
      localError: null,
    };
  }

  componentDidMount() {
    this.props.showNav(false);
  }

  componentWillUnmount() {
    this.props.showNav(true);
  }

  validate = () => {
    const { password, passwordConfirmation } = this.state;
    if (!password || !passwordConfirmation) {
      return 'Please enter and confirm your new password.';
    }
    if (password.length < 6 || password.length > 30) {
      return 'Password must be between 6 and 30 characters.';
    }
    if (password !== passwordConfirmation) {
      return 'Password confirmation does not match.';
    }
    return null;
  };

  submit = (e) => {
    e?.preventDefault();
    const localError = this.validate();
    if (localError) {
      this.setState({ localError });
      return;
    }
    this.setState({ localError: null });
    this.props.changePassword(this.state.password, this.state.passwordConfirmation);
  };

  render() {
    const { password, passwordConfirmation, localError } = this.state;
    const canSubmit = password && passwordConfirmation && !this.props.loading;

    return (
      <div className="login-screen">
        <div className="login-bg" aria-hidden="true">
          <div className="login-glow login-glow-1" />
          <div className="login-glow login-glow-2" />

          <svg
            className="login-wave login-wave-1"
            viewBox="0 0 2880 320"
            preserveAspectRatio="none"
          >
            <path d="M0,160 C240,100 480,220 720,160 C960,100 1200,220 1440,160 C1680,100 1920,220 2160,160 C2400,100 2640,220 2880,160 L2880,320 L0,320 Z" />
          </svg>
          <svg
            className="login-wave login-wave-2"
            viewBox="0 0 2880 320"
            preserveAspectRatio="none"
          >
            <path d="M0,200 C240,140 480,260 720,200 C960,140 1200,260 1440,200 C1680,140 1920,260 2160,200 C2400,140 2640,260 2880,200 L2880,320 L0,320 Z" />
          </svg>
          <svg
            className="login-wave login-wave-3"
            viewBox="0 0 2880 320"
            preserveAspectRatio="none"
          >
            <path d="M0,240 C240,200 480,280 720,240 C960,200 1200,280 1440,240 C1680,200 1920,280 2160,240 C2400,200 2640,280 2880,240 L2880,320 L0,320 Z" />
          </svg>
        </div>

        <main className="login-card">
          <div className="login-card-header">
            <img className="login-card-logo" src="/wave_icon.png" alt="Wave" />
            <h1 className="login-card-title">Set a new password</h1>
            <p className="login-card-subtitle">
              You signed in with a temporary password. Please choose a new one to continue.
            </p>
          </div>

          <form className="login-form" onSubmit={this.submit}>
            <label className="login-field">
              <span className="login-field-label">New password</span>
              <input
                autoFocus
                id="new-password-input"
                className="login-field-input browser-default"
                type="password"
                autoComplete="new-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value, localError: null })}
              />
            </label>

            <label className="login-field">
              <span className="login-field-label">Confirm password</span>
              <input
                id="confirm-password-input"
                className="login-field-input browser-default"
                type="password"
                autoComplete="new-password"
                placeholder="••••••••"
                value={passwordConfirmation}
                onChange={(e) => this.setState({ passwordConfirmation: e.target.value, localError: null })}
              />
            </label>

            {localError && (
              <p className="login-form-error" role="alert">{localError}</p>
            )}

            <p className="login-form-hint">Password must be 6–30 characters.</p>

            <button
              type="submit"
              className="login-submit"
              disabled={!canSubmit}
            >
              {this.props.loading ? 'Saving…' : 'Save password'}
            </button>
          </form>
        </main>

        <footer className="login-footer">
          <img src="/proasys_alt.png" alt="ProAsys" className="login-footer-logo" />
        </footer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.loading,
    user: state.user,
    authToken: state.authToken,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);
